import { useContext } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { ReactComponent as EditIcon } from "assets/images/iconsV2/edit.svg";
import { ShipmentTrackingContext } from "pages/common/ShipmentTracking/ShipmentTrackingContext";
import testIds from "constants/testIds";
import EditScheduleDialog from "../EditScheduleDialog";

function EditSchedule() {
  const { isEditScheduleDialogOpen, setIsEditScheduleDialogOpen } = useContext(ShipmentTrackingContext);

  const handleEditClick = () => {
    setIsEditScheduleDialogOpen(true);
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 0 }}
        overlay={
          <Tooltip id="button-tooltip">
            <FormattedMessage id="components.molecules.navigation.editSchedule" defaultMessage="Edit schedule" />
          </Tooltip>
        }
      >
        <button
          type="button"
          className="topnav-v2__action-btn topnav-v2__edit-btn booked"
          onClick={handleEditClick}
          aria-label="Edit schedule"
          data-testid={testIds.SHIPMENT_DASHBOARD_EDIT_BUTTON}
        >
          <EditIcon />
        </button>
      </OverlayTrigger>
      <EditScheduleDialog isOpen={isEditScheduleDialogOpen} close={() => setIsEditScheduleDialogOpen(false)} />
    </>
  );
}
export default EditSchedule;
